import { gql } from '@apollo/client';

export const ALL_LEARNER_PROGRESSION_STATUS = gql`
  query GetLearnerProgressionStatus {
    data: getLearnerProgressionStatus {
      id
      name
    }
  }
`;
